<template>
  <div class="order-index-vue-scoped-css">
    <el-container class="root_container">
      <el-header style="height: 36px;overflow: hidden;">
        <vHead></vHead>
      </el-header>
      <keep-alive>
        <el-header
          style="height: 100px"
          v-if="$store.state.webInfo.base_conf.is_nav == 1"
          ><vNav></vNav
        ></el-header>
      </keep-alive>
      <div
        class=""
        style="
            display: flex;
            width: 1190px;
            margin: 0 auto;
            justify-content: space-between;
            padding-top: 33px;
            padding-bottom: 20px;
          "
      >
        <div>
          <span
            style="
                height: 40px;
                font-size: 24px;
                margin-top: 5px;
                font-family: MicrosoftYaHei;
                color: #262626;
                line-height: 40px;
              "
            >请确认订单</span
          >
        </div>
        <vProcess :step="step" :titleArr="titleArr"></vProcess>
      </div>

      <div style="width: 1200px; margin: 0px auto">
        <vCard v-if="goodlist[0].source != 2 && goodlist[0].source != 3">
          <div style="box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);">
            <div slot="title" class="card-head" style="height: 60px">
              <div
                class="card-title"
                style="float: left;font-size: 16px;font-weight: bold"
              >
                收货地址信息
              </div>
              <div class="card-add" style="float: right;">
                <a
                  href="#"
                  class=" "
                  style="height: 20px;font-size: 15px;font-family: MicrosoftYaHei;color: #262626;line-height: 20px;"
                  @click="addaddsite()"
                  >+新增收货地址</a
                >
              </div>
            </div>
            <div class="address-list">
              <swiper :options="swiperOptions" ref="mySwiper">
                <swiper-slide
                  v-for="(item, index) in addressShowList"
                  :key="index"
                >
                  <div
                    class="address-row"
                    :class="{
                      'name-choose theme-bd': item.id === chooseAddressIndex
                    }"
                  >
                    <div class="tit">
                      <span v-if="item.id === chooseAddressIndex"
                        >默认地址</span
                      >
                      <button v-else @click="chooseAddressIndex = item.id">
                        设为默认
                      </button>
                      <div>
                        <span>删除</span
                        ><span @click="alteraddress(item.id)">编辑</span>
                      </div>
                    </div>
                    <div class="address-info" style="line-height: 23px;">
                      <div>
                        <span>收货人：</span>
                        <div class="username ellipse" style="max-width: 120px;">
                          {{ item.name }}
                        </div>
                      </div>
                      <div>
                        <span>联系方式：</span>
                        <div class="phone">{{ item.phone }}</div>
                      </div>
                      <div>
                        <span>收货地址：</span>
                        <div class="address">
                          {{ item.province_str }}-{{ item.city_str }}-{{
                            item.county_str
                          }}
                          <span v-if="item.town_str != ''"
                            >-{{ item.town_str }}</span
                          >
                          {{ item.address }}
                        </div>
                      </div>
                    </div>
                    <i
                      class="iconfont iconin_gouxuan defaultAdd theme-col"
                      v-if="item.id === chooseAddressIndex"
                    ></i>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="box-silde" @click="addaddsite()">
                    <p>
                      <span><i class="el-icon-plus"></i></span>
                    </p>
                    <p class="dztj">添加新地址</p>
                  </div>
                </swiper-slide>
              </swiper>
              <div
                class="swiper-button-prev swiper-button-black"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-button-black"
                slot="button-next"
              ></div>
            </div>
          </div>
        </vCard>
        <!--地址弹框-->
        <el-dialog
          :visible.sync="addAddressVisible"
          width="620px"
          center
          class="dztk"
        >
          <div slot="title">
            <!-- <div class="rect theme-bg"></div> -->
            <div class="dialog-title">
              {{ poptype == 1 ? "添加收货地址" : "修改收货地址" }}
            </div>
          </div>
          <div class="demo-input-suffix">
            收&ensp;货&ensp;人：
            <el-input
              class="username"
              placeholder="请输入收货人"
              v-model="name"
            ></el-input>
          </div>
          <div class="demo-input-suffix">
            手机号码：
            <el-input
              class="telnum"
              placeholder="请输入手机号"
              v-model="tel"
            ></el-input>
          </div>
          <div class="linkage">
            所在地区：
            <el-select
              v-model="province"
              @change="choseProvince()"
              placeholder="省"
              id="province"
            >
              <!--这个change事件是select的，不是option的，别写在option里面-->
              <el-option
                v-for="item in province1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="city"
              @change="choseCity"
              placeholder="市"
              id="city"
            >
              <el-option
                v-for="item in city1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-model="county"
              @change="choseBlock"
              placeholder="区"
              id="town"
            >
              <el-option
                v-for="item in county1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select
              v-if="four"
              v-model="town"
              placeholder="乡镇"
              id="county"
              @change="choseTown"
            >
              <el-option
                v-for="item in town1"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="demo-input-suffix">
            详细地址：
            <el-input
              class="where1"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="setess"
            ></el-input>
          </div>
          <!-- <el-checkbox v-model="checked">设为默认地址</el-checkbox> -->
          默认地址：
          <el-tooltip content="设为默认地址" placement="top">
            <el-switch
              width="54"
              v-model="checked"
              active-color="#E23130"
              inactive-color="#e5e5e5"
            >
            </el-switch>
          </el-tooltip>
          <div slot="footer" class="dialog-footer">
            <el-button
              v-if="poptype == 1"
              style="width: 168px;
height: 40px;
background: #E23130;
border-radius: 6px;
border: 1px solid #E23130;"
              class="theme-bg"
              @click="addSite()"
            >
              <span style="color:#fff">确 定</span>
            </el-button>
            <el-button
              v-if="poptype == 2"
              style="width: 168px;
height: 40px;
background: #E23130;
border-radius: 6px;
border: 1px solid #E23130;"
              class="theme-bg"
              @click="sendDatas()"
            >
              <span style="color:#fff">保 存</span>
            </el-button>
          </div>
        </el-dialog>
        <!--地址弹框-->
        <el-dialog
          :visible.sync="tipsVisible"
          width="430px"
          class="qhsp"
          center
        >
          <div slot="title">
            <!-- <div class="rect theme-bg"></div> -->
            <div class="dialog-title">提示</div>
            <!-- <div style="border-bottom: 1px solid #EFEFEF;margin-top: 10px"></div> -->
          </div>
          <div
            style="height: 20px;
font-size: 15px;
text-align:left;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 20px; border-bottom:solid 1px #f5f5f5; padding-bottom:15px;"
          >
            下列商品在当前配送地址库存不足
          </div>
          <div class="no-goods" v-for="item in noinventory" :key="item.id_spro">
            <div class="no-goods-row">
              <div class="img-box">
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{ name: 'Detail', params: { id: item.goods_id } }"
                >
                  <img
                    v-lazy="item.img_path"
                    onerror='src="/static/imgout1.png"'
                    alt=""
                  />
                </router-link>
                <div class="no-product">
                  无货
                </div>
              </div>
              <div class="text-box">
                <span class="jd" v-show="item.source == 1">优选</span>
                <span class="yx" v-show="item.source == 6">严选</span>
                <span class="new" v-show="item.source == 2">直充</span>
                <span class="rob" v-show="item.source == 3">卡券</span>
                {{ item.name }}
              </div>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button
              type="primary"
              style="width: 168px; height:
            40px; background: #E23130; border-radius: 6px; border: 1px solid
            #E23130;"
              @click="tipsVisible = false"
            >
              确定</el-button
            >
          </span>
        </el-dialog>
      </div>

      <!-- 手机 -->
      <div
        class="confirm-card"
        v-if="goodlist[0].source == 2 || goodlist[0].source == 3"
        style="padding:20px; boxsizing:border-box;box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);"
      >
        <vCard>
          <div style="padding:20px 30px;">
            <h3
              style="text-align:left; height: 20px;font-size: 15px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #262626;line-height: 20px;"
            >
              确认信息
            </h3>
          </div>

          <div
            class="phone-box"
            style="margin-left: 40px;  text-align: left;padding-bottom: 20px;"
            v-if="goodlist.length > 0"
          >
            <label v-show="goodlist[0].source == 3" for="Recharge-phone">
              收货人手机号码：</label
            >

            <input
              v-show="goodlist[0].source == 3"
              type="text"
              id="Recharge-phone"
              v-model="phone"
              placeholder="请填写接收短信的11位手机号码"
              style="width: 380px;margin-left:20px; height: 40px;padding-left: 10px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
            />

            <div
              v-show="goodlist[0].source == 3"
              style="margin-left: 124px; margin-top: 10px; font-size: 13px;font-family: MicrosoftYaHei;color: #F36A60;line-height: 17px;"
            >
              温馨提示：请仔细核对收货人手机号码，充值完成后将无法退款！
            </div>

            <div class="tt" v-show="goodlist[0].source == 2">
              <label v-show="goodlist[0].source == 2" for="Recharge-phone"
                >通知号码：</label
              >
              <input
                v-show="goodlist[0].source == 2"
                type="text"
                id="Recharge-phone"
                v-model="phone"
                placeholder="通知号码"
                style="width: 380px;margin-left:20px; height: 40px;padding-left: 10px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
              />
              <div
                v-show="goodlist[0].source == 2"
                style="margin-left: 124px; margin-top: 10px; font-size: 13px;font-family: MicrosoftYaHei;color: #F36A60;line-height: 17px;"
              >
                *用以接收发货通知短信，不填写将无法收到发货通知
              </div>
              <div
                v-for="(vo, key) in inputTp"
                :key="key"
                style="margin-top:10px;"
              >
                <div v-if="vo.name == 'charge_num'">
                  <label style="width:140px" for="Recharge-phone">{{
                    vo.title
                  }}</label>
                  <!-- {{ vo.name }} -->
                  <!-- {{ extParams[vo.name] }} -->
                  <el-select
                    v-if="isChangeNumShow(vo)"
                    v-model="extParams[vo.name]"
                    @change="gameConfirmNum"
                    style="width: 380px;margin-left:20px; height: 40px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
                  >
                    <el-option
                      v-for="(item, index) in vo.enum"
                      :key="index"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <div
                    v-else
                    style="    display: inline-block;
    padding-left: 20px;"
                  >
                    <el-input-number
                      v-model="extParams[vo.name]"
                      :min="Number(vo.range[0][0])"
                      :max="Number(vo.range[0][1])"
                      @change="ChangValue()"
                    ></el-input-number>
                    <span
                      style="margin-left: 10px; margin-top: 10px; font-size: 13px;font-family: MicrosoftYaHei;color: #F36A60;line-height: 17px;"
                      >可输入范围{{ Number(vo.range[0][0]) }}-{{
                        Number(vo.range[0][1])
                      }}</span
                    >
                  </div>
                </div>
                <div v-else>
                  <label style="width:140px" for="Recharge-phone">{{
                    vo.title
                  }}</label>
                  <input
                    type="text"
                    id="Recharge-phone"
                    v-model="extParams[vo.name]"
                    :placeholder="vo.placeholder"
                    style="width: 380px;margin-left:20px; height: 40px;padding-left: 10px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
                  />
                </div>
              </div>
              <div v-if="game.gameList.length > 0" style="margin-top:10px;">
                <label for="Recharge-phone">选择游戏</label>

                <el-select
                  v-model="extParams['charge_game_name']"
                  placeholder="点击选择游戏"
                  @change="gameConfirm"
                  style="width: 380px;margin-left:20px; height: 40px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
                >
                  <el-option
                    v-for="(item, index) in game.gameList"
                    :key="index"
                    value-key="game_name"
                    :label="item.game_name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <div
                v-if="game.gameRegionServer.length > 0"
                style="margin-top:10px;"
              >
                <label for="Recharge-phone">选择游戏区服</label>
                <el-select
                  v-model="game.gameRegionServerText"
                  placeholder="点击选择游戏区服"
                  @change="gameRegionServerConfirm"
                  style="width: 380px;margin-left:20px; height: 40px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
                >
                  <el-option
                    v-for="(item, index) in game.gameRegionServer"
                    :key="index"
                    value-key="text"
                    :label="item.region"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <!-- <van-field
                  v-model="game.gameRegionServerText"
                  is-link
                  readonly
                  name="picker"
                  label="选择游戏区服"
                  placeholder="点击选择游戏区服"
                  @click="game.gameRegionServerPicker = true"
                />
                <van-popup
                  v-model:show="game.gameRegionServerPicker"
                  position="bottom"
                >
                  <van-picker
                    :columns="game.gameRegionServer"
                    value-key="text"
                    :show-toolbar="true"
                    @confirm="gameRegionServerConfirm"
                    @cancel="game.gameRegionServerPicker = false"
                  />
                </van-popup> -->
              </div>

              <div v-if="game.chargetype.length > 0" style="margin-top:10px;">
                <label for="Recharge-phone">选择充值方式</label>
                <el-select
                  v-model="extParams['charge_type']"
                  placeholder="点击选择充值方式"
                  @change="chargetypePickerConfirm"
                  style="width: 380px;margin-left:20px; height: 40px;box-sizing: border-box;font-size: 13px;border-color:#dbdbdb;"
                >
                  <el-option
                    v-for="(item, index) in game.chargetype"
                    :key="index"
                    value-key="text"
                    :label="item.region"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <!-- <van-field
                  v-model="extParams['charge_type']"
                  is-link
                  readonly
                  name="picker"
                  label="选择充值方式"
                  placeholder="点击选择充值方式"
                  @click="game.chargetypePicker = true"
                />
                <van-popup
                  v-model:show="game.chargetypePicker"
                  position="bottom"
                >
                  <van-picker
                    :columns="game.chargetype"
                    :show-toolbar="true"
                    @confirm="chargetypePickerConfirm"
                    @cancel="game.chargetypePicker = false"
                  />
                </van-popup> -->
              </div>
            </div>
          </div>
        </vCard>
      </div>
      <!-- 商品 -->
      <div class="order-info">
        <vCard>
          <div
            slot="title"
            class="card-head"
            style="height: 60px;padding:0px 25px;border-bottom: solid 1px #efefef;"
          >
            <ul
              class="row"
              style="height: 60px; line-height: 60px; border-bottom: none;"
              slot="title"
            >
              <li>订单详情</li>
              <li style="text-align:center;">商品信息</li>
              <li>单价</li>
              <li>数量</li>
              <li>小计</li>
            </ul>
          </div>
          <div
            class="goods-list"
            style=" "
            v-for="item in goodlist"
            :key="item.cart_id"
          >
            <ul class="row" style="overflow: hidden;">
              <li>
                <div class="img-box">
                  <router-link
                    tag="a"
                    target="_blank"
                    :to="{ name: 'Detail', params: { id: item.goods_id } }"
                  >
                    <img
                      v-lazy="item.image"
                      onerror='src="/static/imgout1.png"'
                    />
                  </router-link>
                </div>
              </li>
              <li class="ellipse">{{ item.name }}</li>
              <li>
                <span v-if="item.point"
                  >{{ item.point }} {{ $store.state.name }}</span
                >
                <span v-if="item.cash && item.cash != 0">
                  <span v-if="item.point">+</span>{{ item.cash }}元
                </span>
              </li>
              <!-- {{
                item.source
              }} -->
              <!-- <li v-if="item">{{ item.number }}</li> -->
              <li v-if="goodlist[0].source == 2">
                {{ extParams["charge_num"] }}
              </li>
              <li v-else>{{ item.number }}</li>
              <li v-if="goodlist[0].source == 2" style="white-space: nowrap;">
                <span class="theme-col" v-if="item.point">
                  {{ item.point * extParams["charge_num"]
                  }}{{ $store.state.name }}
                </span>
                <span class="theme-col" v-if="item.cash && item.cash != 0">
                  <span v-if="item.point">+</span
                  >{{ extParams["charge_num"] * item.cash }}元
                </span>
              </li>
              <li v-else style="white-space: nowrap;">
                <span class="theme-col" v-if="item.point">
                  {{ item.point * item.number }}{{ $store.state.name }}
                </span>
                <span class="theme-col" v-if="item.cash && item.cash != 0">
                  <span v-if="item.point">+</span
                  >{{ item.number * item.cash }}元
                </span>
              </li>
              <div class="" style="clear:both;"></div>
            </ul>
          </div>
          <div
            class="remarks"
            v-if="goodlist[0].source != 2 && goodlist[0].source != 3"
          >
            <span style="width:60px;">备注：</span>
            <el-input
              type="textarea"
              placeholder="选填，文字在200字以内"
              v-model="remark"
              onkeyup="this.remark = this.remark.slice(0, 200)"
              maxlength="200"
              show-word-limit
            >
            </el-input>
            <!-- <textarea type="text" placeholder="选填，文字在200字以内" maxlength="200" v-model="remark"></textarea> -->
          </div>
        </vCard>
        <div class="total1">
          <div class="tt">
            <div>
              <span class="total1name">商品数量：</span>
              <span v-if="goodlist[0].source == 2">{{
                extParams["charge_num"]
              }}</span>
              <span class="totalnum" v-else>{{ goodlist.length }}件</span>
            </div>
            <div>
              <span class="total1name">商品总额： </span>
              <span class="totalnum">
                <span v-if="allpoint"
                  >{{ allpoint }} {{ $store.state.name }}</span
                >
                <span v-if="allcash"
                  ><span v-if="allpoint">+</span>{{ allcash }}元
                </span>
              </span>
            </div>
            <div style="white-space: nowrap;">
              <span
                class="total1name"
                style="display: inline-block;height:40px;line-height:50px;"
                >应付总额：</span
              >
              <span class="totalnum ">
                <span v-if="allpoint">
                  <span class="lager">{{ allpoint }}</span>
                  {{ $store.state.name }}
                </span>
                <span v-if="allcash">
                  <span v-if="allpoint">+</span>
                  <span class="lager">{{ allcash }}</span
                  >元
                </span>
              </span>
            </div>
          </div>
        </div>
        <div
          class="submit-box"
          style="display: flex;
    justify-content: flex-end;"
        >
          <!--  v-if="(goodlist[0].source != 2) & (goodlist[0].source != 3)" -->
          <el-button
            class="submit-g1"
            v-if="(goodlist[0].source != 2) & (goodlist[0].source != 3)"
            @click="goCart()"
            >返回{{ $common.cardName().name }}</el-button
          >
          <el-button
            type="primary"
            class=" submit-g theme-bg submit-btn"
            :loading="paybtn"
            @click="tj(1)"
            v-if="goodlist[0].source != 2 && goodlist[0].source != 3"
            >确认提交</el-button
          >
          <el-button
            type="primary"
            class=" submit-g theme-bg submit-btn"
            :loading="paybtn"
            @click="tj(2)"
            v-if="goodlist[0].source == 2 || goodlist[0].source == 3"
            >确认提交</el-button
          >

          <!-- <div>
                合计：
                <span class="theme-col" style="font-size: 20px">{{allpoint}}</span>
                {{$store.state.name}}
              </div>
              <div>
                共
                <span class="theme-col" style="font-size: 16px">{{goodlist.length}}</span>
                件商品
              </div> -->
        </div>
      </div>
    </el-container>
    <el-footer
      style=" background: #ffffff;height:auto;padding:0;border-top:solid 1px #e5e5e5;"
    >
      <vFooter></vFooter>
    </el-footer>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-row
        style="width:562px;    display: flex;
    margin: 0 auto; align-items: center;padding-bottom:80px"
      >
        <el-col style="padding-right:57px;">
          <canvas
            id="paycanvas"
            width="182px"
            style="width:182px;border: 1px solid #C7C7C7;"
          ></canvas>
          <br />
          <div
            style="width: 182px;height: 48px;background: rgb(226, 49, 48);display: flex;justify-content: space-between;color: #fff; padding: 10px 15px;box-sizing: border-box;align-items: center;"
          >
            <img style="width:24px;height:24px;" src="/static/img/sm.png" />
            <p style="color:#fff;font-size: 13px;line-height:17px;width:104px">
              请使用微信扫一扫 扫描二维码支付
            </p>
          </div>
        </el-col>
        <el-col>
          <img style="width:320px;" src="/static/img/phone.png" alt />
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import vFooter from "@/common/footer";
import "swiper/swiper-bundle.css";
import vNav from "@/common/nav";
import vHead from "@/common/header";
import vSearch from "@/common/search";
import vProcess from "@/common/process";
import vCard from "@/common/card";
import Jsonp from "jsonp";
import pay from "@/mixins/pay.js";
export default {
  name: "",
  mixins: [pay],
  data() {
    return {
      paybtn: false,
      step: 2,
      checked: false,
      four: true, //4级地址框
      poptype: 0, //地址框 1新增2修改
      remark: "",
      chooseAddressIndex: "",
      addAddressVisible: false,
      tipsVisible: false,
      titleArr: ["选择商品", "确认订单", "成功提交订单"],
      addressList: [], //地址列表
      showMore: false,
      phone: "",
      goodlist: "", //商品列表
      allpoint: "", //总价
      allcash: 0,
      province: "",
      provinceId: "",
      province1: [],
      city: "",
      ccity: "",
      cityId: "",
      city1: [],
      town: "",
      ctown: "",
      townId: "",
      town1: [],
      street: "",
      county: "",
      ccounty: "",
      county1: [],
      name: "",
      tel: "",
      setess: "",
      id: "",
      noinventory: "",
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        //  autoplay:{depaly:3000},
        observer: true,
        fadeEffect: {
          crossFade: true
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      parameter: [], //卡卷直冲
      inputTp: [],
      extParams: {},
      game: {
        gameList: [],
        gamePicker: false,
        gameRegionServer: [],
        gameRegionServerPicker: false,
        gameRegionServerText: "",
        chargetype: [],
        chargetypePicker: false
      }
    };
  },
  components: {
    vHead,
    vFooter,
    vSearch,
    vProcess,
    vCard,
    vNav,
    swiper,
    swiperSlide
  },
  computed: {
    isChangeNumShow() {
      return vo => {
        return vo.enum && vo.enum.length > 0;
        // vo.range[0].length>0 &&vo.enum.length==0
      };
    },
    //显示全部地址
    addressShowList() {
      console.log(this.addressList);
      return this.addressList;
      // if (this.showMore || this.addressList.length < 3) {
      //   return this.addressList
      // }else{
      //   return this.addressList
      // }
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  watch: {
    remark() {
      if (this.remark.length > 200) {
        this.$message("最多只能输入200个字");

        this.remark = String(this.remark).slice(0, 200);
      }
    }
  },
  methods: {
    goCart() {
      this.$router.push("/cart");
      // this.$router.back();
    },
    ChangValue() {
      console.log(this.goodlist[0].point);
      console.log(this.extParams["charge_num"]);
      this.allpoint = this.goodlist[0].point * this.extParams["charge_num"];
      this.allcash = this.goodlist[0].cash * this.extParams["charge_num"];
      // this.extParams["change_num"] = currentValue;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取地址
    getaddress() {
      this.addressList = [];
      this.$api.get(
        "user/address/list",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == 100) {
            var _this = this;
            $.each(res.data.data, function(index, items) {
              _this.addressList.push(items);
              items.default === 1 ? (_this.chooseAddressIndex = items.id) : "";
              if (items.default === 1) {
                _this.phone = items.phone;
              }
            });
          }
        }
      );
    },
    //获取商品
    getshop() {
      this.$api.get(
        "order/cart/cartorderinfo",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_cart: this.$route.params.id_cfir
        },
        res => {
          this.goodlist = res.data.data.list;
          this.allpoint = res.data.data.point;
          this.allcash = res.data.data.cash;
          this.setGoodsTemplate();
          if (res.data.data.list.length == 0) {
            this.$alert("订单过期请重新下单", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                window.history.go(-1);
              }
            });
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    handleClose(done) {
      this.$confirm("确认取消支付？")
        .then(_ => {
          done();
          this.$router.push({ path: "/user/myorder/orderlist" });
        })
        .catch(_ => {});
    },
    //支付订单
    pay(order) {
      this.wxPay(order);
    },
    //提交订单
    tj(type) {
      if (this.paybtn == false) {
        this.paybtn = true;
        if (type == "1") {
          //1是实物下单
          if (this.chooseAddressIndex == "") {
            this.$alert("请选择配送地址", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.paybtn = false;
              }
            });
            return false;
          }
        } else if (type == "2") {
          //2是虚拟下单
          var reg = /^[1][3456789][0-9]{9}$/;
          if (!reg.test(this.phone)) {
            this.$alert("请填写正确的手机号", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.paybtn = false;
              }
            });
            this.paybtn = false;
            return false;
          }
        }

        this.$api.post(
          "order/orders/confirm",
          {
            id_example: this.$store.state.id_example,
            token_user: this.$store.state.user_id,
            id_cfir: this.$route.params.id_cfir,
            id_address: this.chooseAddressIndex,
            phone: this.phone,
            remark: this.remark,
            pay_type: this.$store.state.webInfo.buy_point,
            extParam: JSON.stringify(this.extParams)
          },
          res => {
            this.$store.commit("cartnum");
            if (res.data.code == 100) {
              this.$confirm("确定支付该订单？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.pay(res.data.data);
                })
                .catch(() => {
                  this.$router.push({ name: "Myorder" });
                });
              // this.$router.push({ name: "Ordersucceed",params:{ordersn:res.data.data} });
            } else if (res.data.code == -99) {
              this.paybtn = false;
              this.tipsVisible = true;
              this.noinventory = res.data.data;
            } else {
              this.paybtn = false;
              this.$alert(res.data.message, "提示", {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          },
          err => {
            this.$router.push({ name: "Overtime" });
          }
        );
      }
    },
    addaddsite() {
      this.name = "";
      this.tel = "";
      this.setess = "";
      this.checked = true;
      this.poptype = 1;
      this.add = true;
      this.province1 = [];
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.province = "";
      this.county = "";
      this.city = "";
      this.town = "";
      this.addAddressVisible = true;
      this.poptype = 1;
      this.adddz();
    },
    //省
    adddz: function(e) {
      this.name = "";
      this.tel = "";
      this.setess = "";
      this.checked = true;
      this.poptype = 1;
      this.add = true;
      this.province1 = [];
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.province = "";
      this.county = "";
      this.city = "";
      this.town = "";
      this.pop0 = false;
      var _this = this;

      // Jsonp('https://fts.jd.com/area/get?fid=4744', null, (err, data) => {
      //        if (err) {
      //          return this.$toast('获取地址失败');
      //        }
      //        let siteData=[]
      //        for (let key in data){
      //     if (key === '52993' || data[key].name === '港澳') {
      //       continue;
      //     }
      //     if (key === '32' || data[key].name === '台湾') {
      //       continue;
      //     }
      //     if (key === '84' || data[key].name === '钓鱼岛') {
      //       continue;
      //     }
      //           if (key === '53283' || data[key].name === '海外') {
      //               break;
      //           }else{
      //               siteData.push(data[key]);
      //           }
      //       }
      //        _this.province1=siteData;
      //      });

      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            _this.province1 = res.data.data;
          }
        }
      );
    },
    // 市
    choseProvince: function() {
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.city = "";
      this.county = "";
      this.town = "";
      this.pop0 = false;
      var _this = this;
      this.cprovince = this.province;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.province, null, (err, data) => {
      //        if (err) {
      //          return this.$toast('获取地址失败');
      //        }
      //        _this.city1=data;
      //      });

      this.$api.post(
        "address/address/getCity",
        { id_example: this.$store.state.id_example, area_id: this.province },
        res => {
          if (res.data.code == 100) {
            _this.city1 = res.data.data;
          }
        }
      );
    },
    // 区
    choseCity: function() {
      this.town1 = [];
      this.county1 = [];
      this.town = "";
      this.county = "";
      this.pop0 = false;
      var _this = this;
      this.ccity = this.city;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.city, null, (err, data) => {
      //        if (err) {
      //          return this.$toast('获取地址失败');
      //        }
      //        _this.county1=data;
      //      });

      this.$api.post(
        "address/address/getCounty",
        { id_example: this.$store.state.id_example, area_id: this.city },
        res => {
          if (res.data.code == 100) {
            _this.county1 = res.data.data;
          }
        }
      );
    },
    // 县
    choseBlock: function() {
      this.town1 = [];
      this.town = "";
      this.ctown = "";
      this.pop0 = false;
      var _this = this;
      this.ccounty = this.county;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.county, null, (err, data) => {
      //   console.log(data)
      //        if (err) {
      //          return this.$toast('获取地址失败');
      //        }
      //        if (data.length === 0) {
      //          this.four = false;
      //        }else{
      //        _this.town1=data;
      //        this.four = true;
      //        }
      //      });

      this.$api.get(
        "address/address/getTown",
        { id_example: this.$store.state.id_example, area_id: this.county },
        res => {
          if (res.data.code == 100) {
            if (res.data.data == false) {
              this.four = false;
            } else {
              this.four = true;
            }
            _this.town1 = res.data.data;
          }
        }
      );
    },
    //镇
    choseTown: function() {
      this.ctown = this.town;
    },
    //修改地址
    chaxuxiugai: function(p, c, co) {
      var _this = this;
      //省
      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            _this.province1 = res.data.data;
          }
        }
      );
      //市
      this.$api.post(
        "address/address/getCity",
        { id_example: this.$store.state.id_example, area_id: this.province },
        res => {
          if (res.data.code == 100) {
            _this.city1 = res.data.data;
          }
        }
      );
      //区
      this.$api.post(
        "address/address/getCounty",
        { id_example: this.$store.state.id_example, area_id: this.city },
        res => {
          if (res.data.code == 100) {
            _this.county1 = res.data.data;
          }
        }
      );
      if (co != 0) {
        //县
        this.$api.get(
          "address/address/getTown",
          { id_example: this.$store.state.id_example, area_id: this.county },
          res => {
            if (res.data.code == 100) {
              if (res.data.data == false) {
                this.four = false;
              } else {
                this.four = true;
              }
              _this.town1 = res.data.data;
            }
          }
        );
      }
    },
    alteraddress(id) {
      this.id = id;
      this.$api.post(
        "user/address/userinfo",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          address_id: id
        },
        res => {
          if (res.data.code == 100) {
            this.poptype = 2;
            this.addAddressVisible = true;
            this.name = res.data.data.name;
            this.tel = res.data.data.phone;
            this.setess = res.data.data.address;
            this.province = res.data.data.province_str;
            this.cprovince = res.data.data.province;
            this.city = res.data.data.city_str;
            this.ccity = res.data.data.city;
            this.county = res.data.data.county_str;
            this.ccounty = res.data.data.county;
            if (res.data.data.town_str != "") {
              this.town = res.data.data.town_str;
              this.ctown = res.data.data.town;
            } else {
              this.four = false;
            }
            res.data.data.default == 1
              ? (this.checked = true)
              : (this.checked = false);
            this.chaxuxiugai(
              res.data.data.province,
              res.data.data.city,
              res.data.data.county
            );
          }
        }
      );
    },
    //添加地址
    addSite: function() {
      var reg = /^1\d{10}$/;
      var yb = /^[0-9]{6}$/;
      if (this.name == "") {
        this.$alert("请输入收货人", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (this.tel == "") {
        this.$alert("手机号码不能为空", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (!reg.test(this.tel)) {
        this.$alert("请输入正确的手机号", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (this.province == "" || this.city == "" || this.county == "") {
        this.$alert("请输入完整地址", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      if (this.town1 != "" && this.town == "") {
        this.$alert("请输入完整地址", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      this.$api.post(
        "user/address/add",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          name: this.name,
          phone: this.tel,
          province: this.province,
          city: this.city,
          county: this.county,
          town: this.town,
          default: this.checked == true ? 1 : 0,
          province_str: $("#province").val(),
          city_str: $("#city").val(),
          county_str: $("#town").val(),
          town_str: $("#county").val() == undefined ? "" : $("#county").val(),
          address: this.setess
        },
        res => {
          if (res.data.code == 100) {
            this.addAddressVisible = false;
            this.getaddress();
            this.$alert("添加成功", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    //保存修改地址
    sendDatas: function() {
      if (this.town1 != "" && this.ctown == "") {
        this.$alert("请输入完整的地址", "提示", {
          confirmButtonText: "确定",
          callback: action => {}
        });
        return false;
      }
      this.$api.post(
        "user/address/update",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_address: this.id,
          name: this.name,
          phone: this.tel,
          province: this.cprovince,
          city: this.ccity,
          county: this.ccounty,
          town: this.ctown,
          default: this.checked == true ? 1 : 0,
          province_str: $("#province").val(),
          city_str: $("#city").val(),
          county_str: $("#town").val(),
          town_str: $("#county").val() == undefined ? "" : $("#county").val(),
          address: this.setess
        },
        res => {
          if (res.data.code == 100) {
            setTimeout(() => {
              this.addAddressVisible = false;
              this.getaddress();
            });
          } else {
            this.$alert("请输入完整的地址", "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        }
      );
    },
    gameConfirmNum(val) {
      this.extParams["charge_num"] = val;
      this.allpoint = this.goodlist[0].point * this.extParams["charge_num"];
      this.allcash = this.goodlist[0].cash * this.extParams["charge_num"];
    },

    setGoodsTemplate() {
      console.log(this.goodlist);
      let product_list = this.goodlist,
        template = product_list[0].extParams;
      console.log(template.parameter);
      if (this.goodlist[0].source != 2 || !template) return;
      let parameter = template.parameter,
        specialName = [
          "charge_game_name",
          "charge_game_region",
          "charge_game_srv",
          "charge_type"
        ];
      console.log(parameter);
      let inputList = [],
        extParams = {};
      parameter.forEach((item, index) => {
        let placeholder = "请输入" + item.title;
        let range = item.range;
        let tp_enum = item.enum;
        console.log(tp_enum);

        // let range = JSON.parse(item.range);
        // let tp_enum = JSON.parse(item.enum);
        // if (tp_enum.length > 0 || range.length > 0) {
        //   if (range.length > 0) {
        //     for (let index in range) {
        //       tp_enum.unshift(range[index][0] + "-" + range[index][1]);
        //     }
        //   }
        //   if ((range.length >= 0) & (tp_enum.length == 0)) {
        //   }

        //   placeholder += ",范围：" + tp_enum.join("|");
        // }
        // item.placeholder = placeholder;
        if (specialName.indexOf(item.name) === -1) {
          inputList.push(item);
        }
        extParams[item.name] = "";
        if (tp_enum.length > 0) {
          this.allpoint = this.goodlist[0].point * tp_enum[0];
          this.allcash = this.goodlist[0].cash * tp_enum[0];

          extParams["charge_num"] = tp_enum[0];
        }
      });
      this.inputTp = inputList;
      this.parameter = parameter;
      this.game.gameList = template.game_list;
      this.extParams = extParams;
      console.log(this.extParams);
    },
    gameConfirm(val, d) {
      console.log(val, d);
      this.extParams.charge_game_name = val.game_name;
      if (val.game_region_server && val.game_region_server.length > 0) {
        let game_region_server = val.game_region_server;
        game_region_server.forEach(function(val, key) {
          if (val.region && val.server) {
            val.text = val.region + "-" + val.server;
          } else {
            if (val.region) val.text = val.region;
            else val.text = val.server;
          }
          game_region_server[key] = val;
        });
        this.game.gameRegionServer = game_region_server;
      }
      this.game.gamePicker = false;
    },
    gameRegionServerConfirm(val) {
      this.game.gameRegionServerText = val.text;
      if (val.region) this.extParams.charge_game_region = val.region;
      if (val.server) this.extParams.charge_game_srv = val.server;
      if (val.charge_type) this.game.chargetype = val.charge_type;
      this.game.gameRegionServerPicker = false;
    },
    chargetypePickerConfirm(val) {
      this.extParams.charge_type = val;
      this.game.chargetypePicker = false;
    }
  },
  mounted() {
    this.getshop();
    this.getaddress();
  }
};
</script>

<style lang="less" scoped>
.box-silde {
  height: 154px;
  border: 1px dashed #979797;
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    border: 1px dashed #e23130;
  }
  span {
    margin-top: 40px;
    width: 40px;
    height: 40px;
    background: #d8d8d8;
    display: inline-block;
    border-radius: 50%;
    color: #fff;
    line-height: 40px;
    i {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .dztj {
    margin-top: 10px;
    height: 19px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #7a7a7a;
    line-height: 19px;
  }
}
.swiper-button-prev:after {
  font-size: 12px;
}
.swiper-button-next:after {
  font-size: 12px;
}
/deep/ .dztk .el-dialog--center {
  border-radius: 6px;
  overflow: hidden;
}
/deep/ .el-switch__core:after {
  width: 26px;
  height: 26px;
  top: -1px;
  left: -1px;
  border: 1px solid #dbdbdb;
  box-shadow: 4px 0px 4px 0px rgba(159, 159, 159, 0.3);
}
/deep/ .el-switch__core {
  height: 26px;
  line-height: 26px;
  border-radius: 13px;
  border-radius: 13px;
  boxsizing: border-box;
}
/deep/ .el-switch.is-checked .el-switch__core:after {
  box-shadow: -4px 0px 4px 0px #c92524;

  border: 1px solid #e23130;
}
/deep/ .el-dialog__header {
  background: #f5f5f5;
  padding-top: 10px;
}
/deep/ .dialog-title {
  margin: 5px 0px !important;
  font-size: 24px !important;
  color: #262626 !important;
}
/deep/ .qhsp .el-dialog--center .el-dialog__body {
  padding-top: 15px !important;
  height: 277px;
  box-sizing: border-box;
  overflow-y: scroll;
}
.goods-list {
  padding: 0px 25px;
  border-bottom: solid 1px #e5e5e5;
}
.swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: #b1b1b1; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 10px; /* 设置按钮大小 */
  width: 1113px;
  margin: 0 auto;
  position: relative;
}
.submit-g {
  width: 219px;
  height: 48px;
  background: #e23130;
  border-radius: 6px;
  border: 1px solid #e23130;
  color: #fff;
}
.submit-g1 {
  width: 219px;
  height: 48px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #bebebe;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #535353;
  margin-right: 23px;
  transition: all 0.25s;
}
.submit-g1:hover {
  background: rgba(226, 49, 48, 0.1);
  border: 1px solid #e23130 !important;
  color: #e23130 !important;
}
.total1 {
  display: flex;
  justify-content: flex-end;
  background: #fff;
  padding-right: 45px;
  padding-bottom: 30px;
  border-bottom: solid 1px #efefef;
  .tt {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
    }
  }
  .total1name {
    height: 17px;
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #272727;
    line-height: 17px;
  }
  .totalnum {
    height: 17px;
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #e23130;
    line-height: 17px;
  }
  .lager {
    height: 40px;
    font-size: 30px;
    font-family: MicrosoftYaHei;
    color: #e23130;
    line-height: 40px;
  }
}
.tit {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px dashed rgba(151, 151, 151, 0.5);
  span {
    font-size: 13px;
    font-family: MicrosoftYaHei;
    color: #272727;
  }
  div {
    span {
      height: 17px;
      font-size: 13px;
      font-family: MicrosoftYaHei;
      color: #175fa0;
      line-height: 17px;
      margin-left: 20px;
    }
  }
  button {
    width: 68px;
    height: 23px;
    background: #ffffff;
    border-radius: 4px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #262626;
    // line-height: 23px;
    border: 1px solid #b9b9b9;
    transition: all 0.25s;
    &:hover {
      background: #f5f5f5;
    }
  }
}

.box-bg {
  background: url("/static/img/card_bg.png") no-repeat;
  background-size: 100%;
  background-color: #fff;
}
.address-box {
  width: 1200px;
  margin: 0px auto;
}
.card-title,
.card-add {
  padding: 20px;
}
.address-list {
  padding: 0px 20px 20px 20px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  --swiper-navigation-size: 22px; /* 设置按钮大小 默认是44px */
  .more-address {
    padding-bottom: 26px;
  }
}
.address-row {
  clear: both;
  position: relative;
  // width: 356px;
  background: #f5f5f5;
  padding: 11px 20px;
  box-sizing: border-box;
  border: solid 1px #f5f5f5;
  transition: all 0.25s;
  &:hover {
    border: solid 1px #e23130;
  }
}
.name {
  width: 172px;
  line-height: 23px;
  border: 2px solid #e6e6e6;
  box-sizing: border-box;
  float: left;
  padding: 8px 0px;
  margin-left: 20px;
  color: #515151 !important;
  position: relative;
  .defaultAdd {
    display: none;
  }
}
.name-choose {
  .defaultAdd {
    font-size: 32px;
    display: block;
    position: absolute;
    bottom: -2px;
    right: -1px;
  }
}
.address-info {
  & > div {
    display: flex;
    box-sizing: border-box;
    margin-top: 10px;
    align-items: center;
    span {
      height: 19px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #7a7a7a;
      line-height: 19px;
      margin-right: 15px;
      white-space: nowrap;
    }
  }
  &:hover {
    background-color: #f4f4f4;
  }
  .address {
    max-width: 337px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .operate {
    & > div {
      display: none;
    }
  }
  .edit {
    cursor: pointer;
    margin-right: 30px;
  }
  &:hover .edit {
    display: inline-block;
  }
}
.icon-default {
  padding: 6px 0px !important;
  box-sizing: border-box;
}

.default {
  box-sizing: border-box;
  height: 24px;
  padding: 2px 4px;
  color: #fff;
  background-color: #999999;
}
.more-btn {
  cursor: pointer;
  margin-left: 20px;
  float: left;
  color: #5c5c5c;
}
.icon-down {
  transform: rotate(-90deg);
}
.icon-up {
  transform: rotate(90deg);
}
.goods-box {
  margin: 30px auto 0px auto;
}
.row {
  height: 130px;
  line-height: 130px;
  //border-bottom:1px dashed #DFDFDF;
}
.row > li {
  box-sizing: border-box;
  float: left;
  &:nth-child(1) {
    font-weight: bold;
    font-size: 16px;
    width: 10%;
    text-align: left;
  }
  &:nth-child(2) {
    width: 40%;
    padding-left: 90px;
    box-sizing: border-box;
    text-align: left;
  }
  &:nth-child(3) {
    width: 20%;
  }
  &:nth-child(4) {
    width: 10%;
  }
  &:nth-child(5) {
    width: 20%;
  }
}
.img-box {
  img {
    width: 100px;
    height: 100%;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
  }
  .no-product {
    width: 46px;
    height: 46px;
    line-height: 46px;
    font-size: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(38, 38, 38, 0.5);
    color: #fff;
    border-radius: 46px;
    text-align: center;
  }
}
.line {
  width: 1178px;
  border-bottom: 2px dashed #dfdfdf;
  margin-left: 11px;
}
.remarks {
  margin-top: 29px;
  color: #515151;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  // align-items: center;
  textarea {
    height: auto;
    padding: 9px;
    padding-top: 30px;
    margin-left: 10px;
    width: 1052px;
    border-color: #e6e7e7;
  }
  /deep/ .el-textarea__inner {
    border-color: #e6e7e7 !important;
    // padding-top: 10px !important;
  }
}
.submit-box {
  // margin-top: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 45px;
  // margin-bottom: 100px;
  background-color: #fff;
  .submit-btn {
    cursor: pointer;
    // width: 127px;
    color: #fff !important;
    width: 219px;
    height: 48px;
    background: #e23130;
    border-radius: 6px;
    border: 1px solid #e23130;
    float: right;
  }
  & > div {
    float: right;
  }

  & > div:nth-child(2) {
    padding: 17px 0px;
    margin-right: 16px;
  }
  & > div:nth-child(3) {
    margin-right: 27px;
    padding: 21px 0px 19px 0px;
  }
}
.score-text {
  color: #323232;
}
.rect {
  width: 25px;
  height: 6px;
  border-radius: 3px;
  margin: -8px auto 0px auto;
}
.dialog-title {
  color: #0f2134;
  margin-top: 8px;
  font-size: 16px;
  letter-spacing: 2px;
  font-weight: 500;
}
.no-goods {
  margin: 0px auto 0px auto;
  width: 360px;
  // height: 178px;
  overflow-y: auto;
}
.no-goods::-webkit-scrollbar {
  width: 4px;
  height: 16px;
  background-color: #ededed;
}

/*定义滑块 内阴影+圆角*/
.no-goods::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #c7c7c6;
}
.no-goods {
  margin-top: 18px;
  .no-goods-row {
    clear: both;
    margin-bottom: 18px;
    .img-box {
      margin: 0;
      width: 80px;
      height: 80px;
      float: left;
      position: relative;
      img {
        width: 100%;
        height: auto;
      }
    }
    .text-box {
      width: 228px;
      float: left;
      margin-left: 40px;
      // margin-top: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;

      margin-left: 22px;
      margin-top: 20px;
    }
  }
}
.order-info {
  margin: 30px auto 0px auto;
  width: 1200px;

  margin-bottom: 40px;
  // box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
}
.card-title {
  float: left;
  font-size: 16px;
  font-weight: bold;
}
</style>
<style lang="less" scoped>
.tt {
  label {
    width: 98px !important;
    display: inline-block;
  }
}
.order-index-vue-scoped-css {
  /*地址弹框*/
  .amendinfo {
    left: 75px;
    position: relative;
    top: -60px;
  }
  .amendinfo span {
    display: inline-block;
    width: 80px;
    height: 38px;
    background: #fff;
    position: absolute;
    top: 1px;
    line-height: 38px;
    font-size: 14px;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .pop1 {
    left: 15px;
  }
  .pop2 {
    left: 154px;
  }
  .pop3 {
    left: 294px;
  }
  .pop4 {
    left: 430px;
  }
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__close {
    position: relative;
    top: -5px;
  }
  .el-dialog {
    width: 680px;
    height: 540px;
    box-shadow: 2px 2px 5px #555;
    /* border: 5px solid #ccc; */
  }
  .el-dialog__header {
    padding: 10px 20px 10px;
    background: #f5f5f5;
  }
  .username.el-input,
  .telnum.el-input {
    width: 285px;
    height: 38px;
    margin-left: 4px;
  }
  .demo-input-suffix {
    margin-bottom: 20px;
    /* height: 36px; */
  }
  .linkage .el-input__inner {
    width: 100px;
    font-size: 12px;
  }
  .el-select {
    margin-right: 5px;
    margin-bottom: 20px;
  }
  .where1 {
    width: 400px;
    margin-left: 4px;
    vertical-align: middle;
  }
  .el-checkbox {
    margin-left: 74px;
  }

  .el-dialog__body {
    padding: 20px 20px 0 50px;
  }
  .dialog-footer button {
    width: 125px;
    height: 42px;
  }
  .el-dialog__header {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
  }
  .el-select {
    width: 100px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/affirmOrder/index.vue